import React, { useEffect, useState } from 'react';
import Chat from './components/Chat';
import consentService from './services/consent-service';
import { languageService } from './services/language-service';
import './App.css';

function App() {
  // Track the current language to update the iframe src
  const [currentLanguage, setCurrentLanguage] = useState(languageService.getLanguage());

  useEffect(() => {
    // For development: Reset the consent state to ensure ToS appears
    consentService.resetConsent();
    
    // Request consent when app loads (force show for testing)
    const initializeConsent = async () => {
      await consentService.requestInitialConsent(true);
    };
    
    initializeConsent();

    // Set up a listener for language changes
    const handleStorageChange = (e) => {
      if (e.key === 'cognimates_copilot_language') {
        setCurrentLanguage(e.newValue);
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  return (
    <div className="app-container">
      <div className="codelab-container">
        <iframe
          src={`https://hackidemia.github.io/cognimates-gui/?lang=${currentLanguage}`}
          title="Cognimates Codelab"
          className="codelab-iframe"
          id="cognimates-iframe"
        />
      </div>
      <div className="chat-container">
        <Chat onLanguageChange={(lang) => setCurrentLanguage(lang)} />
      </div>
    </div>
  );
}

export default App;
